import { TransactionViewTrackingContext } from '../enums/transactionViewTrackingContext'

const isTransactionViewTrackingContext = (value?: string): value is TransactionViewTrackingContext =>
  Object.values(TransactionViewTrackingContext).includes(value as TransactionViewTrackingContext)

export const getTransactionViewTrackingContext = (value?: string): TransactionViewTrackingContext =>
  isTransactionViewTrackingContext(value) ? value : TransactionViewTrackingContext.Ember
